export const PAYMENT_INIT_ATTEMPTS = 3;
export const PAYMENT_INIT_TIMEOUT_MS = 5_000;
export const PAYMENT_REQUEST_TIMEOUT_MS = 15_000;
export const PAYMENT_SCRIPT_TIMEOUT_MS = 30_000;
export const PAYMENT_INIT_RETRY_DELAY_MS = 400;
export const PAYMENT_INIT_RETRY_FACTOR = 3;
export const PAYMENT_INTENT_MIN_LIFETIME_MS = 60_000;
export const PAYMENT_SWITCH_SLOW_MS = 10_000;

export const PAYMENT_INTENT_ASSUMED_LIFETIME_MS = 30 * 60_000;

export const PAYMENT_INIT_ACTION = {
  SDK: 'init_sdk',
  CARD_INTENT: 'init_card_intent',
  GOOGLE_PAY: 'init_google_pay',
  APPLE_PAY: 'init_apple_pay',
  PAYPAL: 'init_paypal',
} as const;

export const CHARGEBEE_ORIGIN = 'https://js.chargebee.com';
export const CHARGEBEE_API_DOMAIN = 'chargebee.com';
export const STRIPE_API_ORIGIN = 'https://api.stripe.com';
export const CHARGEBEE_SCRIPT_SRC = 'https://js.chargebee.com/v2/chargebee.js';
export const PAYPAL_SCRIPT_SRC = 'https://www.paypalobjects.com/api/checkout.min.js';
export const GOOGLE_PAY_ORIGIN = 'https://pay.google.com';
